import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { type NeuronTag } from "./services/neurons/types";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Converts a camelCase string to Title Case with spaces
 * @example
 * convertCamelCaseToTitle("propertyManagement") // returns "Property Management"
 * convertCamelCaseToTitle("dataAnalysis") // returns "Data Analysis"
 */
export function convertCamelCaseToTitle(str: string): string {
	// Handle empty or invalid input
	if (!str) return '';
	
	// Split by capital letters and join with space
	const words = str.replace(/([A-Z])/g, ' $1').trim();
	// Capitalize first letter and return
	return words.charAt(0).toUpperCase() + words.slice(1);
}

export const tagDisplayNameMap: Record<NeuronTag, string> = {
	acquisition: "Acquisition",
	marketing: "Marketing",
	propertyManagement: "Property Management",
	youtubeVideo: "Youtube Video",
	webScraper: "Web Scraper",
	analysis: "Analysis",
	other: "Additional Tools",
};

export const formatDate = (dateString: string | null) => {
	if (!dateString) return "N/A";

	const date = new Date(dateString);
	const now = new Date();
	const diffTime = Math.abs(now.getTime() - date.getTime());
	const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
	const diffYears = Math.floor(diffDays / 365);

	if (diffDays === 0) {
		return "Today";
	}
	if (diffDays === 1) {
		return "Yesterday";
	}
	if (diffDays < 7) {
		return `${diffDays} days ago`;
	}
	if (diffDays < 30) {
		return `${Math.floor(diffDays / 7)} weeks ago`;
	}
	if (diffDays < 365) {
		return `${Math.floor(diffDays / 30)} months ago`;
	}
	if (diffYears === 1) {
		return "1 year ago";
	}
	if (diffYears < 3) {
		return `${diffYears} years ago`;
	}

	return date.toLocaleDateString(undefined, {
		year: "numeric",
		month: "short",
		day: "numeric",
	});
};
